export default "/_next/static/images/e414007bea87337245051627a9035efb.png";